import type { IAPI } from '../../apiResponse';
import { getRequest } from '../../httpClient';
import {
  getPublicCollectionBySlugV4ResponseSchema,
  type ICollectionV4,
} from './get-public-collection-by-slug-v4-response';

export async function getPublicCollectionBySlugV4Api(slug: string) {
  return getRequest<IAPI<ICollectionV4>>({
    path: `/collections/v4/slug/${encodeURIComponent(slug)}`,
    schema: getPublicCollectionBySlugV4ResponseSchema,
  });
}
